export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./pin-list.vue?vue&type=template&id=05a0788a&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/common/pin-list.vue?vue&type=template&id=05a0788a&scoped=true
// module id = IipW
// module chunks = 0